/**
 * PATH: apps/quote/src/components/builder/panels/ai-assistant/CoverageResultDisplay.tsx
 * PURPOSE: Coverage check result display with progress ring
 */

import type { CoverageCheckResult } from '@/lib/quoteApi'

export default function CoverageResultDisplay({ result }: { result: CoverageCheckResult }) {
  const coveragePercent = result.coverage_percent || 0

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-3">
        <div className="relative w-16 h-16">
          <svg viewBox="0 0 36 36" className="w-full h-full rotate-[-90deg]">
            <path
              d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
              fill="none" stroke="#e2e8f0" strokeWidth="3"
            />
            <path
              d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
              fill="none"
              stroke={coveragePercent >= 80 ? '#22c55e' : coveragePercent >= 60 ? '#f59e0b' : '#ef4444'}
              strokeWidth="3" strokeDasharray={`${coveragePercent}, 100`}
            />
          </svg>
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="text-lg font-bold">{Math.round(coveragePercent)}%</span>
          </div>
        </div>
        <div>
          <p className="text-sm font-medium text-slate-900 dark:text-white">Scope Coverage</p>
          <p className="text-xs text-slate-500">{result.covered_areas || 0} of {result.total_areas || 0} areas</p>
        </div>
      </div>

      {result.missing_areas && result.missing_areas.length > 0 && (
        <div>
          <p className="text-xs font-medium text-amber-600 mb-1">Missing Areas</p>
          <div className="flex flex-wrap gap-1">
            {result.missing_areas.map((area, i) => (
              <span key={i} className="px-2 py-0.5 text-xs bg-amber-100 dark:bg-amber-900/30 text-amber-800 dark:text-amber-200 rounded">
                {area}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
